export const displayPrices = (number: number) =>
  (number / 100).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
  })

export const centsToDollar = (number: number) => number / 100
export const dollarToCents = (number: number) => number * 100
